import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from "reactstrap";
import { routes } from "../../routers/routes";
import { BreadcrumbsProps } from "../../types/CoreComponents";
import SvgIcon from "../SvgIcon";
import SubHeader from "./SubHeader";
import { useNavigate } from "react-router-dom";
import { LucideArrowLeft } from "lucide-react";
const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ mainTitle, parent }) => {
  const navigate = useNavigate();
  const canGoBack = window.history.length > 1;

  return (
    <Container fluid>
      <div className="page-title" style={{ marginBottom: "10px" }}>
        <Row className="d-flex justify-content-between align-items-center">
          {/* Left side: Back button + Title */}
          <Col className="d-flex align-items-center gap-2">
            <button
              onClick={() => navigate(-1)}
              disabled={!canGoBack}
              style={{
                display: "inline-flex",
                alignItems: "center",
                background: "none",
                border: "none",
                cursor: canGoBack ? "pointer" : "default",
                padding: 0,
                opacity: canGoBack ? 1 : 0.4,
              }}
            >
              <LucideArrowLeft color={canGoBack ? "black" : "#aaa"} />
            </button>

            <h3 className="mb-0">{mainTitle}</h3>
          </Col>

          {/* Right side: Breadcrumb */}
          <Col xs="auto">
            <Breadcrumb className="mb-0">
              <BreadcrumbItem>
                <Link to={routes.AllUsers}>
                  <SvgIcon className="stroke-icon" iconId="stroke-home" />
                </Link>
              </BreadcrumbItem>

              <BreadcrumbItem>{parent}</BreadcrumbItem>
              <BreadcrumbItem active>{mainTitle}</BreadcrumbItem>
            </Breadcrumb>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Breadcrumbs;
